// @ts-nocheck
import { Card, Code, Stack, Text, Title } from '@/components/ui';
import {
  HeatmapWidget,
  CalendarHeatmap,
} from '../../../../components/advanced/Widgets';
import {
  mockTimeHeatmapData,
  mockCalendarHeatmapData,
  mockRegionActivityHeatmap,
} from '../../mockData/widgets';

export default function HeatmapWidgetsPage() {
  return (
    <Stack gap="xl">
      <Stack gap="xs">
        <Title order={2}>Heatmap Widgets</Title>
        <Text c="dimmed" size="sm">
          Visualize activity intensity patterns over time or across categories. Perfect for
          identifying trends, peaks, and patterns in large datasets.
        </Text>
      </Stack>

      {/* Time Heatmap */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>HeatmapWidget - Time Activity</Title>
          <Text size="sm" c="dimmed">
            Activity heatmap showing patterns across hours and days. Automatically color-codes
            intensity levels.
          </Text>

          <HeatmapWidget
            title="User Activity by Time"
            subtitle="Activity patterns over the week"
            data={mockTimeHeatmapData}
            xAxisLabel="Hour of Day"
            yAxisLabel="Day of Week"
            cellSize={24}
            tooltipFormatter={(cell) => `${cell.label}: ${cell.value} activities`}
          />

          <Code block>
{`<HeatmapWidget
  title="User Activity by Time"
  data={timeActivityData}
  xAxisLabel="Hour of Day"
  yAxisLabel="Day of Week"
  cellSize={24}
/>`}
          </Code>
        </Stack>
      </Card>

      {/* Calendar Heatmap */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>CalendarHeatmap - GitHub Style</Title>
          <Text size="sm" c="dimmed">
            Year-view calendar heatmap showing daily activity. Similar to GitHub's contribution
            graph.
          </Text>

          <CalendarHeatmap
            title="Activity Over the Year"
            subtitle="365 days of contribution"
            data={mockCalendarHeatmapData}
            startDate={new Date(new Date().getTime() - 365 * 24 * 60 * 60 * 1000)}
            endDate={new Date()}
            tooltipFormatter={(data) => `${data.date}: ${data.count} activities`}
          />

          <Code block>
{`<CalendarHeatmap
  title="Activity Over the Year"
  data={yearlyActivityData}
  startDate={oneYearAgo}
  endDate={today}
/>`}
          </Code>
        </Stack>
      </Card>

      {/* Region Activity */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>HeatmapWidget - Regional Activity</Title>
          <Text size="sm" c="dimmed">
            Activity heatmap showing patterns across different regions and time slots.
          </Text>

          <HeatmapWidget
            title="Global User Activity"
            subtitle="By region and time slot"
            data={mockRegionActivityHeatmap}
            xAxisLabel="Time Slot (UTC)"
            yAxisLabel="Region"
            cellSize={32}
            cellGap={4}
          />

          <Code block>
{`<HeatmapWidget
  title="Global User Activity"
  data={regionalData}
  cellSize={32}
  cellGap={4}
/>`}
          </Code>
        </Stack>
      </Card>

      {/* Use Cases */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Title order={4}>Common Use Cases</Title>
          <Text size="sm">
            <strong>Activity Patterns:</strong> Identify peak usage times and quiet periods
            <br /><br />
            <strong>Contribution Tracking:</strong> Visualize daily contributions over time
            <br /><br />
            <strong>Resource Usage:</strong> Monitor server load patterns across time zones
            <br /><br />
            <strong>User Behavior:</strong> Understand when and how users engage with your platform
          </Text>
        </Stack>
      </Card>
    </Stack>
  );
}
